import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import Select from '../Select';
import { InputTypes, validFormElementValue } from '../../utils/validateFormElement';

class SelectComponent extends FormComponent {
	init(questionData) {
		this.renderInputField(questionData);
	}
	markup(value, data, titleMarkup) {
		this.selectContainerClass = `lta-select-container-${data.id}`;
		const placeholder = data.placeholder ? this.renderPlaceholder(data.placeholder) : this.renderPlaceholder('Please select');
		const selectOptions = data.options.map((option) => this.renderSelectOptions(option)).join('');
		const inputID = `lta-select-component-id-${data.id}`;
		const hasValue = this.data?.value !== undefined && this.data?.value !== null && this.data?.value !== '';
		const labelElement = data.titlePattern
			? ``
			: `<label for="${inputID}" class="lta-select__label lta-text-input__label u-text-grey-lta"" id="lta-select-label-example-two">${data.label}</label>`;
		return `<div class="lta-select-component">
						<div class="lta-select-component-title">${titleMarkup}</div>
						<div class="${this.selectContainerClass} lta-form-check-group lta-content--fields u-mb-5">
						<div class="lta-select">
						${labelElement}
						${data.instructionText ? `<p class="u-body2 u-mb-1">${data.instructionText}</p>` : ''}
						<div class="lta-text-input--error"></div>
						<div class="js-lta-select lta-select__wrapper" data-is-multiselect="false" tabindex="0">
						<select name="" id="example-two">
							${placeholder}
							${selectOptions}
						</select>
						<div class="lta-select__box u-text-grey-lta"">
							<div class="lta-select__selected" role="combobox" aria-controls="lta-select-items-example-two" aria-expanded="false" aria-haspopup="listbox" aria-labelledby="lta-select-label-example-two" aria-owns="lta-select-items-example-two" id="lta-select__selected-example-two" aria-activedescendant="">
								<span></span>
								<div class="lta-select__caret-down lta-select__caret-rotate ${hasValue ? 'u-hidden' : ''}" aria-hidden="true">
                                    <svg class="lta-icon js-lta-text-input--btn-icon" width="1rem" height="1rem" fill="currentColor" alt="caret-down-fill" aria-hidden="true">
                                    <use xlink:href="/static/images/icons/lta-icons.svg#caret-down-fill"></use>
                                    </svg>
                                </div>
                                <button type="button" class="lta-btn lta-select__clear u-p-0 ${!hasValue ? 'u-hidden' : ''}" aria-label="clear selection">
                                    <svg class="lta-icon js-lta-text-input--btn-icon" width="1rem" height="1rem" fill="currentColor" alt="close" aria-hidden="true">
                                    <use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
                                    </svg>
                                </button>
							</div>
							<div class="lta-select__items-wrapper lta-select__items-wrapper--hide" id="lta-select-items-example-two" role="listbox">
							</div>
						</div>
						</div>
					</div>
				</div>
			<div></div>`;
	}

	renderPlaceholder(placeholder) {
		return `<option value="" disabled selected hidden>${placeholder}</option>`;
	}
	renderSelectOptions(option) {
		const selectOptionID = `select-question-${this.data.id}-${option.id}`;
		const selectedTag = option.label === this.data?.value ? 'selected' : '';
		return `<option value="${option.id}" data-ss-id="${selectOptionID}" id="${selectOptionID}" ${selectedTag}>${option.label}</option>`;
	}
	afterRender() {
		this.selectContainerElement = SelectorEngine.findOne(`.${this.selectContainerClass}`, this._element);
		this.selectElement = SelectorEngine.findOne('.js-lta-select', this.selectContainerElement);
		this.selectComponentElement = Select.getInstance(this.selectElement) || new Select(this.selectElement);
		EventHandler.on(
			this.selectComponentElement._selectNativeElement,
			'change',
			this.selectComponentChangeHandler.bind(this)
		);
		
		if (this.data?.value) {
			setTimeout(() => {
				this.selectComponentChangeHandler();
			}, 0);
		}
	}
	selectComponentChangeHandler() {
		this.selectedOptionValue = this.selectComponentElement._selectNativeElement.value;
		this.validate();

		const selectedOptionObject = this?.data.options?.find((option) => option.id == this.selectedOptionValue);
		if (selectedOptionObject) {
			this.value = {
				...selectedOptionObject,
				fieldName: this?.data.fieldName,
				value: selectedOptionObject.label
			};
			if (this.value) {
				this.dependentQuestion = this.value.dependentQuestion;
			}
		}
	}
	validate() {
		const formElementData = {
			element: this.selectContainerElement,
			formElement: this.selectComponentElement._selectNativeElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_SELECT,
			hasIcon: false
		};
		return this.data?.isOptional ? true : validFormElementValue(this.selectedOptionValue, formElementData);
	}
}
export default SelectComponent;
